import React from 'react';
import { STEPS } from '../../utils/billSteps';
import { CheckIcon } from '../common/icons';

/** Seven billing steps; done steps can be revisited when `canOpen(index)` allows it. */
export default function StepRail({ current, reached, canOpen, onOpen }) {
  return (
    <ol className="dp-steps" aria-label="Billing steps">
      {STEPS.map((step, i) => {
        const done = i < reached && i !== current;
        const openable = i !== current && canOpen(i);
        return (
          <li key={step.id} className={`dp-step${i === current ? ' is-current' : ''}${done ? ' is-done' : ''}`}>
            <button type="button" onClick={() => openable && onOpen(i)} disabled={!openable} aria-current={i === current ? 'step' : undefined}>
              <span className="dp-step-dot">{done ? <CheckIcon size={13} /> : i + 1}</span>
              <span className="dp-step-text">
                <strong>{step.label}</strong>
                <small>{step.hint}</small>
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
